module.exports = __webpack_public_path__ + "img/maps.1fab2747.svg";